import { SignIn } from "@clerk/clerk-react";
import { C, FONT_STACK } from "../constants/colors";
import { TERMS_URL, PRIVACY_URL } from "../constants/legal";
import BrillLogo from "./BrillLogo";

export function LoginScreen() {
  return (
    <div style={{
      minHeight: "100vh", background: C.indigo,
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      padding: "20px", fontFamily: FONT_STACK,
    }}>
      <div style={{ marginBottom: 32, textAlign: "center" }}>
        <BrillLogo height={72} style={{ margin: "0 auto" }} />
      </div>
      <SignIn
        appearance={{
          elements: {
            rootBox: { width: "100%", maxWidth: 420 },
            card: { background: "#fff", borderRadius: 16, boxShadow: "0 20px 60px rgba(0,0,0,0.3)", border: "none" },
            headerTitle: { color: C.indigo, fontWeight: 700 },
            headerSubtitle: { color: "#888" },
            formButtonPrimary: { background: C.teal, borderRadius: 10, fontWeight: 600, "&:hover": { background: C.tealDark } },
            formFieldInput: { borderRadius: 8, border: "1.5px solid #e0dfe8", fontSize: 15 },
            footerActionLink: { color: C.teal },
            socialButtonsBlockButton: { borderRadius: 10, border: "1.5px solid #e0dfe8" },
          }
        }}
      />
      {/* TERMS AND PRIVACY AT THE FOOT (her call, 2026-10-12): where a sign-in
          page keeps them, so the logo sits alone above the box. Inside the app
          they live in Settings → Account. */}
      <div style={{ marginTop: 24, display: "flex", gap: 12, justifyContent: "center" }}>
        <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" style={{ color: "#8b8899", fontSize: 11, textDecoration: "none" }}>Terms & Conditions</a>
        <span style={{ color: "#5c5970", fontSize: 11 }}>·</span>
        <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={{ color: "#8b8899", fontSize: 11, textDecoration: "none" }}>Privacy Policy</a>
      </div>
    </div>
  );
}
